import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["accountId"],
  _excluded2 = ["phone"];
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, Grid, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { useStore } from 'src/stores';
import { newTeamMemberSchema } from 'src/utils/formValidation/NewTeamMember';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
export const EditTeamMemberModalContent = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    data = _ref.data,
    handleEditModalSuccess = _ref.handleEditModalSuccess;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accountId = data.accountId,
    restData = _objectWithoutProperties(data, _excluded);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isSumbitDisabled = _useState2[0],
    setIsSumbitDisabled = _useState2[1];
  const formik = useFormik({
    initialValues: _objectSpread({}, restData),
    validationSchema: newTeamMemberSchema,
    enableReinitialize: true,
    onSubmit: async values => {
      const phone = values.phone,
        rest = _objectWithoutProperties(values, _excluded2);
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const phoneData = phone.length > 0 ? {
        phone: "".concat(phoneCode).concat(phone)
      } : {
        phone: null
      };
      const currentData = beforeSubmitDataValidation(_objectSpread(_objectSpread({}, phoneData), rest));
      if (currentData.firstName !== restData.firstName || currentData.lastName !== restData.lastName) {
        const updateFirstLastNamesAsync = await store.account.updateProfileByAccountIdAsync.run({
          accountId: accountId,
          firstname: currentData.firstName,
          lastname: currentData.lastName
        });
        if (!updateFirstLastNamesAsync || !updateFirstLastNamesAsync.isSuccessful) return;
      }
      if (currentData.email !== restData.email) {
        const updateEmailAsync = await store.account.updateEmailByAccountIdAsync.run({
          accountId: accountId,
          email: currentData.email
        });
        if (!updateEmailAsync || !updateEmailAsync.isSuccessful) return;
      }
      if (currentData.phone.length > 0 && currentData.phone !== restData.phone || currentData.phone.length === 0 && restData.phone && restData.phone.length > 0) {
        const updatePhoneAsync = await store.account.updatePhoneByAccountIdAsync.run({
          accountId: accountId,
          phone: currentData.phone
        });
        if (!updatePhoneAsync || !updatePhoneAsync.isSuccessful) return;
      }
      toast('success', {
        body: ['Successfully saved']
      });
      handleEditModalSuccess();
      handleModalClose();
    }
  });
  const validIsSumbitDisabled = (id, value) => {
    const _formik$values = formik.values,
      currentField = _formik$values[id],
      rest = _objectWithoutProperties(_formik$values, [id].map(_toPropertyKey));
    const tempValues = _objectSpread({
      [id]: value
    }, rest);
    tempValues.phone = tempValues.phone.replaceAll('-', '');
    const currentValues = beforeSubmitDataValidation(tempValues);
    for (const prop in currentValues) {
      if (currentValues[prop] !== restData[prop]) {
        setIsSumbitDisabled(false);
        break;
      } else {
        setIsSumbitDisabled(true);
      }
    }
  };
  useEffect(() => {
    formik.setFieldTouched('email', true);
    formik.setFieldTouched('phone', true);
    formik.setFieldTouched('lastName', true);
    formik.setFieldTouched('firstName', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: formik.values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('firstName', e.target.value);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    label: t('general.last_name'),
    variant: "outlined",
    value: formik.values.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('lastName', e.target.value);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "email",
    name: "email",
    label: t('general.email_address'),
    variant: "outlined",
    value: formik.values.email,
    onBlur: e => {
      if (e.target.email) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('email', e.target.value);
    },
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.touched.email && translate(formik.errors.email, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
      validIsSumbitDisabled('phone', e.target.value);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number_optional'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '286-edit-teammember-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "text",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || isSumbitDisabled || store.account.updateProfileByAccountIdAsync.inProgress || store.account.updateEmailByAccountIdAsync.inProgress || store.account.updatePhoneByAccountIdAsync.inProgress,
    'custom-attribute': '287-edit-teammember-modal'
  }, t('buttons.save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.account.updateProfileByAccountIdAsync.inProgress || store.account.updateEmailByAccountIdAsync.inProgress || store.account.updatePhoneByAccountIdAsync.inProgress
  }));
});